import React from 'react';
import { SplitImageBodyPanel } from '../Panel/Split';

export const Error = ({ body, image }) => (
  <div className='flex items-center min-h-screen w-screen h-screen'>
    <SplitImageBodyPanel
      image={image}
      body={body}
    />
  </div>
);
